import { Logo } from "./Logo";

const Header = () => (
  <header
    data-testid="site-header"
    className="fixed inset-x-0 top-0 z-50 bg-charcoal/95 backdrop-blur-xl"
  >
    <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-3.5 md:px-6">
      <a href="#inicio" aria-label="SalonUP — voltar ao topo" data-testid="header-logo-link">
        <Logo dark />
      </a>

      <p className="hidden text-[11px] font-medium uppercase tracking-[0.18em] text-white/60 md:block">
        Pronto para gerir com mais clareza?
      </p>

      <a
        href="#lancamento"
        data-testid="header-cta-button"
        className="inline-flex shrink-0 items-center rounded-full border border-white/70 px-4 py-2 text-xs font-medium text-white transition-colors duration-300 hover:bg-white hover:text-charcoal md:px-5 md:py-2.5 md:text-sm"
      >
        <span className="md:hidden">Quero ser avisado</span>
        <span className="hidden md:inline">Quero ser avisado do lançamento</span>
      </a>
    </div>
  </header>
);

export { Header };
